import { tv } from 'tailwind-variants'

import { body2 } from '@ui-kit/core/typography'

export const languageSwitcher = tv({
  slots: {
    container: 'flex flex-row items-center border-none text-ui-dark lg:mx-12',
    text: body2({ type: 'primary' }),
    disabledLanguage: 'opacity-40',
    separator: 'px-0.5',
  },
})
